import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20elegant%20lifestyle%20flatlay%20composition%20with%20premium%20home%20decor%20items%2C%20silk%20fabric%2C%20ceramic%20vase%2C%20wooden%20furniture%2C%20and%20soft%20textiles%20on%20a%20cream%20background%2C%20artistic%20editorial%20photography%20with%20warm%20golden%20tones%20and%20gentle%20shadows%2C%20sophisticated%20minimalist%20aesthetic&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="久久精品 品质生活"
        title="久久精品——品质经久不衰的精选好物平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 tracking-wide">
          品质经久不衰
        </h1>
        <p className="text-sm md:text-lg text-white/90 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
          久久精品汇聚全球优质精选商品，以严苛品控与持久品质为核心，
          为您甄选每一件经得起时间考验的精品。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/家居好物"
            className="px-8 py-3 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            探索好物
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-medium whitespace-nowrap rounded-md bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm transition-colors cursor-pointer"
          >
            了解久久
          </Link>
        </div>
      </div>
    </section>
  );
}